import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	loadPaymentHistories, loadPaymentsForChild,
	PAYMENTS_BY_CHILD_REQUEST, PAYMENTS_BY_CHILD_SUCCESS, PAYMENTS_BY_CHILD_FAILURE
} from '../paymentHistory/actions';
import List from '../paymentHistory/List';
import Timeline from '../paymentHistory/Timeline';
import authUtils from '../../auth/utils';
import { Button } from 'react-bootstrap';
import { DropdownList } from 'react-widgets';
import ReduxBlockUi from 'react-block-ui/redux';
import { withTranslation } from 'react-i18next';
import { Panel } from 'react-bootstrap';

class PaymentHistories extends Component {
	constructor(props) {
		super(props);
		this.handleViewSwitch = this.handleViewSwitch.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleChildSelect = this.handleChildSelect.bind(this);

		const { children } = this.props.parent;
		const firstChild = children && children[0];
		this.state = {
			selectedChildId: firstChild && firstChild.id,
			selectedView: 'list'	// list or timeline
		};
	}

	componentDidMount() {
		this.loadListData({ pageNumber: 1, pageSize: this.props.pagination.pageSize });
		this.loadTimelineData();
	}

	loadListData({ sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadPayments({ parentId: this.props.parent.id, sortKey, sortDirection, pageSize, pageNumber });
	}

	loadTimelineData() {
		if (this.state.selectedChildId) {
			this.props.loadPaymentsForChild(this.state.selectedChildId);
		}
	}

	handleViewSwitch() {
		this.setState({
			selectedView: this.state.selectedView === 'list' ? 'timeline' : 'list'
		});
	}

	handleListEvent(listPagination) {
		this.loadListData({ ...listPagination });
	}

	handleChildSelect(value) {
		this.setState({ selectedChildId: value.id }, () => this.loadTimelineData());
	}

	render() {
		const { isReadonly, parent, payments, pagination, paymentsByChildFilter, schoolYears, t } = this.props;
		const { selectedChildId, selectedView } = this.state;

		let data = [], viewComponent = null, switchViewResource = '';
		switch (selectedView) {
			case 'list':
				data = (pagination || { ids: [] }).ids.map(id => payments[id]);
				switchViewResource = 'Enrolments_View_Timeline';
				viewComponent = <List isReadonly={isReadonly} onFetchData={this.handleListEvent} data={data} {...this.props.pagination} parentId={parent.id} />;
				break;
			case 'timeline':
				if (selectedChildId) {
					data = (paymentsByChildFilter[selectedChildId] || { ids: [] }).ids.map(id => payments[id]);
				}
				switchViewResource = 'Enrolments_View_List';

				viewComponent = <Panel>
					<Panel.Body>
						{parent.children && parent.children.length > 0 && (parent.children.length > 1 ?
							<DropdownList data={parent.children} defaultValue={parent.children[0]} textField='fullName' valueField='id' onChange={this.handleChildSelect} /> :
							<h4 style={{ textAlign: 'center' }}>{parent.children[0].fullName}</h4>)}
						<ReduxBlockUi block={PAYMENTS_BY_CHILD_REQUEST} unblock={[PAYMENTS_BY_CHILD_SUCCESS, PAYMENTS_BY_CHILD_FAILURE]} renderChildren={false}>
							{(!data || data.length === 0) && <div style={{ textAlign: 'center', marginTop: '5px' }}>{t('List_Empty')}</div>}
							<Timeline data={data} schoolYears={schoolYears} />
						</ReduxBlockUi>
					</Panel.Body>
				</Panel>;
				break;
		}

		return <div>
			<div style={{ marginBottom: '10px' }}><Button bsStyle='success' onClick={this.handleViewSwitch}>{t(switchViewResource)}</Button></div>
			{viewComponent}
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const parentId = ownProps.parent && ownProps.parent.id;

	const {
		pagination,
		entities: { paymentHistories },
		filters: { paymentsByChild },
		lookups: { schoolYears },
		auth: { currentUser }
	} = state;

	const paymentHistoriesPagination = pagination.paymentHistories[parentId] || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		payments: paymentHistories,
		pagination: paymentHistoriesPagination,
		paymentsByChildFilter: paymentsByChild,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'PaymentHistory'),
		schoolYears
	};
};

export default connect(mapStateToProps, {
	loadPayments: loadPaymentHistories,
	loadPaymentsForChild
})(withTranslation()(PaymentHistories));